import { Component, OnInit, Input } from '@angular/core';
import { EventEmitterService } from 'services/event-emitter.service';
import { SplashService } from 'services/splash.service';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.css']
})
export class SplashComponent implements OnInit {
  splashHTML: string;

  constructor(private eventEmitterService: EventEmitterService, private splashService: SplashService) {
    this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateSplashHTML(res));
   }

  ngOnInit(): void {
  }

  updateSplashHTML(res: string)
  {
    this.splashHTML = res;
  }

}
